import React, { useEffect, useState } from "react";
import PageHeader from "../../components/PageHeader";
import DeployTrigger from "../../components/DeployTrigger";
import Help from "../../components/Help";
import { helpPagesData } from "../../utils/helper";
import { useToast } from "../../components/ToastProvider";
import { useNavigate } from "react-router-dom";
import { fetchOrganizationList } from "../../action/organizationaction";
import { CreateNewProject } from "../../action/Projectsaction";

const AddProjects = () => {
  const { showToast } = useToast();
  const navigate = useNavigate();

  const [organizations, setOrganizations] = useState([]);
  const [form, setForm] = useState({
    name: "",
    email: "",
    mobile: "",
    domains: [],
    organization_id: ""
  });

  const loadOrganizations = async () => {
    const res = await fetchOrganizationList(1, 50);
    if (res.status === 1) setOrganizations(res.data.list);
  };

  useEffect(() => {
    loadOrganizations();
  }, []);

  const handleCreate = async () => {
    const res = await CreateNewProject(form);
    if (res?.data?.status === 1) {
      showToast("Project created successfully", "success");
      navigate("/projects");
    } else {
      showToast(res?.message || "Failed to create project", "error");
    }
  };

  return (
    <>
      <PageHeader pageTitle="Add Project">
         
          <Help title={helpPagesData.pages.title} message={helpPagesData.pages.message} items={helpPagesData.pages.items} />
      </PageHeader>

      <div className="page-container">
        <div className="theme-card p-4">
          <label className="frm-label">Name</label>
          <input className="frm-input" placeholder="Enter Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />

          <label className="frm-label mt-2">Email</label>
          <input className="frm-input"placeholder="Enter Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />

          <label className="frm-label mt-2">Mobile</label>
          <input className="frm-input" placeholder="Enter Mobile Number" value={form.mobile} onChange={(e) => setForm({ ...form, mobile: e.target.value })} />

          <label className="frm-label mt-2">Domains (Example: domain1.com,domain2.com)</label>
          <input
            className="frm-input"
            value={form.domains.join(",")}
            placeholder="Enter Domain"
            onChange={(e) => setForm({ ...form, domains: e.target.value.split(",") })}
          />

          <label className="frm-label mt-2">Select Organization</label>
          <select
            className="frm-input"
            value={form.organization_id}
            onChange={(e) => setForm({ ...form, organization_id: e.target.value })}
          >
            <option>Select Organization</option>
            {organizations.map((o) => (
              <option key={o._id} value={o._id}>
                {o.name}
              </option>
            ))}
          </select>

          <div className="header-btn-group mt-4">
            <button className="btn-black ms-auto" onClick={handleCreate}>Create</button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddProjects;
